import { render } from "./Cookies.vue?vue&type=template&id=6a1fc0c2&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=6a1fc0c2&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=6a1fc0c2&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src944962216/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a1fc0c2"]])

export default __exports__